import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { ApiService } from '@APP/services/api-service';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators';
import { commonPopupStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from '../components/device-aware-component';

type Deps = {
  apiService: ApiService;
};

@requires(ApiService.serviceName)
@customElement('congrats-popup')
export class CongratsPopup extends DepInjMixin<Deps>(DeviceAwareComponent) {
  static get styles() {
    return [commonPopupStyle];
  }

  @state()
    contentLoaded = false;

  connectedCallback() {
    super.connectedCallback();
    import(/* webpackChunkName: 'congrats' */ '../components/congrats').then(() => this.contentLoaded = true);
    this.deps.apiService.unlock();
  }

  render() {
    return this.contentLoaded
      ? html`<lh-congrats></lh-congrats> `
      : html``;
  }
}
